export default {
  computed: {
    $settingBlockSize() {
      return 3;
    },
  }
}